/* apis/setup/MapZone.ts */

import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { MapZone, MapZoneCoordinate, Project } from 'models/setup/mobile/MapZone';
import { SetupProject } from 'models/setup/SetupProject';
import { callApi } from 'utils/ApiUtil';

/**
 * API 응답 인터페이스
 */
interface SaveResponse {
  success: boolean;
  message: string;
  savedCount?: number;
}

/**
 * 프로젝트 목록 조회
 */
export const getProjects = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: '/v1/mobilesetup/project',
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<Project[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as Project[];
};

/**
 * 하역장이 존재하는 프로젝트 목록 조회
 */
export const gertProjectsZonValidated = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: '/v1/mobilesetup/project/zonValidated',
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<SetupProject[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as SetupProject[];
};

/**
 * 구역 목록 조회
 */
export const getMapZones = async (
  searchPrjId: string,
  searchZonNm: string,
  searchUseYn: string
) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: '/v1/mobilesetup/map/zones',
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      elmPrjId: searchPrjId,
      zonNm: searchZonNm,
      useYn: searchUseYn,
    }),
  };
  const response: CommonResponse<MapZone[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as MapZone[];
};

/**
 * 구역 좌표 목록 조회
 */
export const getMapZoneCoordinates = async (mapZonId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mobilesetup/map/zones/${mapZonId}/coordinates`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<MapZoneCoordinate[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as MapZoneCoordinate[];
};

/**
 * 구역 목록 저장
 */
export const setMapZones = async (saveData: MapZone[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: '/v1/mobilesetup/map/zones/save',
    serviceName: ServiceName.ELM_BE,
    bodyParams: saveData,
  };
  const response: CommonResponse<SaveResponse> = await callApi(request);

  return response.successOrNot === 'Y' ? response.data : null;
};

/**
 * 구역 좌표 목록 저장
 */
export const setMapZoneCoordinates = async (saveData: MapZoneCoordinate[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: '/v1/mobilesetup/map/coordinates/save',
    serviceName: ServiceName.ELM_BE,
    bodyParams: saveData,
  };
  const response: CommonResponse<SaveResponse> = await callApi(request);

  return response.successOrNot === 'Y' ? response.data : null;
};
